import {
  APP_SETTING_UPDATE_DATE_FORMAT_BEGIN,
  APP_SETTING_UPDATE_DATE_FORMAT_SUCCESS,
  APP_SETTING_UPDATE_DATE_FORMAT_FAILURE,
  APP_SETTING_UPDATE_DATE_FORMAT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateDateFormat(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_DATE_FORMAT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/dateFormat`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_UPDATE_DATE_FORMAT_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_DATE_FORMAT_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_DATE_FORMAT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateDateFormatError() {
  return {
    type: APP_SETTING_UPDATE_DATE_FORMAT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_DATE_FORMAT_BEGIN:
      return {
        ...state,
        updateDateFormatPending: true,
        updateDateFormatError: null,
      };

    case APP_SETTING_UPDATE_DATE_FORMAT_SUCCESS:
      return {
        ...state,
        updateDateFormatPending: false,
        updateDateFormatError: null,
        projectDetail: {
          ...state.projectDetail,
          dateFormat: action.data.dateFormat,
        },
      };

    case APP_SETTING_UPDATE_DATE_FORMAT_FAILURE:
      return {
        ...state,
        updateDateFormatPending: false,
        updateDateFormatError: action.data.error,
      };

    case APP_SETTING_UPDATE_DATE_FORMAT_DISMISS_ERROR:
      return {
        ...state,
        updateDateFormatError: null,
      };

    default:
      return state;
  }
}
